import moment from "moment";

const getTokenStatus = expireTime => {
  const now = moment();
  const timeToExpire = moment(expireTime);

  return now.isSameOrAfter(timeToExpire);
};

export default getTokenStatus;
